export const sectionTypes = [
    {
        key: 'sms',
        value: 'SMS',
        name: 'SMS',
        id: 1,
    },
    {
        key: 'mail',
        value: 'Mail',
        name: 'Mail',
        id: 2,
    },
    {
        key: 'document',
        value: 'Document',
        name: 'Document',
        id: 3,
    },
    {
        key: 'attachment',
        value: 'Ek',
        name: 'Attachment',
        id: 4,
    },
    {
        key: 'PushNotification',
        value: 'Anl?k Bildirim',
        name: 'Push Notification',
        id: 5,
    },
];
